import type { components } from '@fluencelabs/vodopad-admin-api'
import { getDefaultFilter } from '@refinedev/antd'
import type { CrudFilters } from '@refinedev/core'
import { useCustom } from '@refinedev/core'
import { Form, type FormProps, Select, Space } from 'antd'
import { useMemo } from 'react'

import { UserSearchSelect } from '@/components/common/UserSearchSelect'
import { VODOPAD_ENDPOINT } from '@/constants/constants'
import { PAYMENT_INTENT_STATUSES } from '@/constants/payments'

type PaymentMethodDto = components['schemas']['PaymentMethodDto']

interface Props {
  searchFormProps: FormProps
  filters: CrudFilters
}

export function PaymentsFilterForm({ searchFormProps, filters }: Props) {
  const methodsQuery = useCustom<PaymentMethodDto[]>({
    url: `${VODOPAD_ENDPOINT}/v2/admin/payment-methods`,
    method: 'get',
  })

  const methods = useMemo(
    () =>
      (methodsQuery.query.data?.data as PaymentMethodDto[] | undefined) ?? [],
    [methodsQuery.query.data],
  )

  const providerOptions = useMemo(
    () =>
      [...new Set(methods.map((m) => m.provider))].map((p) => ({
        label: p,
        value: p,
      })),
    [methods],
  )

  const methodCodeOptions = useMemo(
    () =>
      [...new Set(methods.map((m) => m.methodCode))].map((c) => ({
        label: c,
        value: c,
      })),
    [methods],
  )

  return (
    <Form
      {...searchFormProps}
      layout="inline"
      style={{ marginBottom: 16 }}
      initialValues={{
        status: getDefaultFilter('status', filters, 'eq'),
        userId: getDefaultFilter('userId', filters, 'eq'),
        provider: getDefaultFilter('provider', filters, 'eq'),
        methodCode: getDefaultFilter('methodCode', filters, 'eq'),
      }}
    >
      <Space wrap>
        <Form.Item name="status" noStyle>
          <Select
            placeholder="Status"
            style={{ width: 160 }}
            allowClear
            onChange={() => searchFormProps.form?.submit()}
            options={PAYMENT_INTENT_STATUSES.map((s) => ({
              label: s,
              value: s,
            }))}
          />
        </Form.Item>
        <Form.Item name="userId" noStyle>
          <UserSearchSelect onChange={() => searchFormProps.form?.submit()} />
        </Form.Item>
        <Form.Item name="provider" noStyle>
          <Select
            placeholder="Provider"
            style={{ width: 160 }}
            allowClear
            onChange={() => searchFormProps.form?.submit()}
            options={providerOptions}
          />
        </Form.Item>
        <Form.Item name="methodCode" noStyle>
          <Select
            placeholder="Method"
            style={{ width: 160 }}
            allowClear
            onChange={() => searchFormProps.form?.submit()}
            options={methodCodeOptions}
          />
        </Form.Item>
      </Space>
    </Form>
  )
}
